import React, { useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { ContactService } from 'gw-capability-gateway';
import metadata from './AccountContactSearchComponent.metadata.json5';
import './AccountContactSearchComponent.messages';
import styles from './AccountContactSearchComponent.module.scss';
import SearchContactComponent from '../SearchContactComponent/SearchContactComponent';
import ContactComponent from '../ContactComponent/ContactComponent';

function AccountContactSearchComponent(props) {
    const {
        submissionVM,
        onValueChange,
        authHeader,
        accountNumber,
        updateWizardData,
        isPolicyChange,
        updateSubmission
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const { EndorsementService } = useDependencies('EndorsementService');
    const [searchPniContact, setSearchPniContact] = useState(false);
    const [addPniContact, setAddPniContact] = useState(false);
    const [newContactVM, setNewContactVM] = useState({});
    const [pniNames, setPniNames] = useState([{}]);
    const [defaultPni, setDefaultPni] = useState({ name: submissionVM.baseData.primaryNamedInsured_Ext.displayName.value, code: submissionVM.baseData.primaryNamedInsured_Ext.publicID.value });
    const [isEditPniName, setEditPniName] = useState(false);


    useEffect(() => {

        const placeHolder = { name: 'Search contact', id: 'search'};
        const value = submissionVM.baseData.account_Ext.accountContacts.value.map(contact => 
             ({ name: contact.displayName, code: contact.publicID })

        );

        value.push(placeHolder);
        setPniNames(value);
        setDefaultPni({name: submissionVM.baseData.primaryNamedInsured_Ext.displayName.value , code:submissionVM.baseData.primaryNamedInsured_Ext.publicID.value });
    }, [submissionVM]);

    const updateContacts = async (contact) => {
        await updatePrimaryNamedInsured(contact.publicID);
        setSearchPniContact(false);
        setAddPniContact(false);
    }

    const onAdditionalInsuredInterestChange = (value) => {
           if(value === 'search') {
               setSearchPniContact(true);
           } else {
            updatePrimaryNamedInsured(value);
           }

    }

    // ~ Update the primary Named insured
   const updatePrimaryNamedInsured = async(value) => {
        const updatePNIPromise = isPolicyChange ? EndorsementService : LoadSaveService;
        const jobID = isPolicyChange ? submissionVM.jobID.value : submissionVM.quoteID.value;

        await updatePNIPromise.updatePrimaryNamedInsured_Ext(jobID, value, authHeader)
            .then(response => {
                const pni = response;

                setDefaultPni({ name: pni.displayName, code: pni.publicID });
                setEditPniName(false);

                const newSubmissionVM = viewModelService.clone(submissionVM);

                _.set(newSubmissionVM, 'baseData.primaryNamedInsured_Ext.value', response);

                if (isPolicyChange) {
                    updateSubmission(newSubmissionVM);
                } else {
                    updateWizardData(newSubmissionVM);
                }
            });

   };
    const updateNewPrimaryNamesInsuredContact = async(data) => {

        const contact = await ContactService.createAccountContact(submissionVM.baseData.accountNumber.value, data, authHeader);
        const newSubmissionVM = viewModelService.clone(submissionVM);

        newSubmissionVM.baseData.account_Ext.accountContacts.value.push(contact);
        _.set(newSubmissionVM, 'baseData.primaryNamedInsured_Ext.value', contact);
        updateWizardData(newSubmissionVM);

        const prePniNames =  pniNames;

        prePniNames.push({ name: contact.displayName, id: contact.contactPublicID})
        setPniNames(prePniNames);
        setDefaultPni({ name: contact.displayName, id: contact.contactPublicID});
        setEditPniName(false);
        updatePrimaryNamedInsured(contact.contactPublicID);
    }

    const handleAddExistingContact = (contact) => {
        updateContacts(contact);
    }


    const handlePniSearchCancel = () => {
        setSearchPniContact(false);
        setAddPniContact(false);
        setEditPniName(false);
    };

    const createVM = (model) => viewModelService.create(
            model,
            'pc',
            'edge.capabilities.gateway.contact.dto.AccountContactDetailsDTO'
        );

    const handleAddNewClick = () => {
        const contactModel =  {
            subtype: "Person",
            primaryAddress: {
                country: "CA",
                state: "ON",
                isFromPortal: true,
            },
            isFromPortal: true,
            active:true,
            accountContactRoles:[
                {
                    subtype:'NamedInsured'
                }
            ]
        }

        setNewContactVM(createVM(contactModel));
        setSearchPniContact(false);
        setAddPniContact(true);
    }

    const saveContact = () => {
        const data = newContactVM.value

        data.displayName = `${data.firstName  } ${  data.lastName}`;
        updateNewPrimaryNamesInsuredContact(data);
        setSearchPniContact(false);
        setAddPniContact(false);
    }

    const onNewValueChange = (value, path) => {
        const newContactVm = viewModelService.clone(newContactVM);

        _.set(newContactVm, path, value)
        setNewContactVM(newContactVm);
    }

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            onValueChange,
            showRequired: true
        },

        readOnlyPrimaryNamedInsured: {
            value: defaultPni.name,
        },
        readOnlyPrimaryNamedInsuredContainer: {
            visible: !isEditPniName
        },
        editAdditionalInsuredInterest : {
            onClick: (e) => { setEditPniName(true) },
        },
        searchContact: {
            visible: searchPniContact,
            authHeader,
            accountNumber,
            updateContacts,
            viewModelService,
            handleAddNew: handleAddNewClick,
            handleCancel: handlePniSearchCancel,
            handleAddExistingContact
        },
        addNewContainer: {
            visible: addPniContact
        },
        addContact: {
            contactVM: newContactVM,
            onValueChange: onNewValueChange,
            viewModelService
        },
        saveContactBtn: {
            onClick: saveContact,
        },
        cancelContactBtn: {
            onClick: handlePniSearchCancel
        },
        additionalInsured: {
            availableValues: pniNames,
            value: defaultPni,
            onValueChange: onAdditionalInsuredInterestChange,
            visible: isEditPniName
        },
    };

    const resolvers = {
        resolveCallbackMap: {
        },
        resolveComponentMap: {
            searchContactComponent: SearchContactComponent,
            contactComponent: ContactComponent
        },
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={submissionVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

AccountContactSearchComponent.propTypes = {
    availableValues: PropTypes.array
}
export default AccountContactSearchComponent;
